import api from './api';

export const folderService = {
  // Get organized folder structure (Cases/Templates/Personal)
  getOrganized: async () => {
    const response = await api.get('/folders/organized');
    return response.data;
  },

  // List all folders
  listFolders: async (parentId = null) => {
    const params = parentId ? { parent_id: parentId } : {};
    const response = await api.get('/folders/', { params });
    return response.data;
  },

  // Get folder details with subfolders
  getFolder: async (folderId) => {
    const response = await api.get(`/folders/${folderId}`);
    return response.data;
  },

  // Get cases for a contact
  getContactCases: async (contactId) => {
    const response = await api.get(`/folders/cases/${contactId}/cases`);
    return response.data;
  },

  // Create folder
  createFolder: async (name, parentId = null) => {
    const response = await api.post('/folders/', {
      name,
      parent_id: parentId,
    });
    return response.data;
  },
};
